import React, { useRef } from 'react';
import { trackButtonActivity } from 'src/functions/propagateQueryParams';
import Heading from '../../../../elements/typography/heading';
import Paragraph from '../../../../elements/typography/paragraph';
import { LinkGroupContainer, StyledFooterA, StyledFooterLink } from './Footer.links.styles';

export interface FooterLinkGroupProps {
  title: string;
  links: {
    text: string;
    url: string;
    external?: boolean;
  }[];
}

export const FooterLink = ({ link }: { link: FooterLinkGroupProps['links'][0] }): JSX.Element => {
  const buttonRef = useRef<any>();

  // Extend onClick listener for Trackers, etc.
  const trackOnClick = () => {
    trackButtonActivity(buttonRef.current);
    return true;
  };

  if (link.external) {
    return (
      <StyledFooterA
        className='footer-link'
        href={link.url}
        target='_blank'
        rel='noopener noreferrer'
        ref={buttonRef}
        onClick={trackOnClick}
      >
        <Paragraph
          text={link.text}
          weight='light'
          standardSize='1'
          sizeLg='0.85em'
        />
      </StyledFooterA>
    );
  }
  return (
    <StyledFooterLink
      className='footer-link'
      to={link.url}
      ref={buttonRef}
      onClick={trackOnClick}
    >
      <Paragraph
        text={link.text}
        weight='light'
        standardSize='1'
        sizeLg='0.85em'
      />
    </StyledFooterLink>
  );
};

const FooterLinkGroup = ({ title, links }: FooterLinkGroupProps): JSX.Element => {
  return (
    <LinkGroupContainer>
      <Heading
        text={title}
        fontFamily='Mulish'
        standardSize='1.25'
        weight='light'
        data-section-notrack='true'
      />
      {links.map((link) => (
        <FooterLink
          link={link}
          key={link.url}
        />
      ))}
    </LinkGroupContainer>
  );
};

export default FooterLinkGroup;
